import * as React from 'react';
import { FeatureFlags } from '@authe/fe-commons/flags';
import { jsx } from 'react/jsx-runtime';

// src/flags/FlagsProvider.tsx
var FlagsContext = React.createContext(null);
function FlagsProvider({ flags, children }) {
  return /* @__PURE__ */ jsx(FlagsContext.Provider, { value: flags, children });
}
function useFeatureFlags() {
  const flags = React.useContext(FlagsContext) ?? EMPTY_FLAGS;
  React.useSyncExternalStore(flags.subscribe, flags.getRevision, flags.getRevision);
  return flags;
}
function useFeatureFlag(name) {
  return useFeatureFlags().isEnabled(name);
}
function useRolledOut() {
  const flags = useFeatureFlags();
  const revision = flags.getRevision();
  return React.useCallback(
    (flag) => !flag || flags.isEnabled(flag),
    // `revision` is not read inside — it is what makes the identity change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [flags, revision]
  );
}
function useFeatureVariant(name) {
  return useFeatureFlags().variantOf(name);
}
var EMPTY_FLAGS = new FeatureFlags();

export { FlagsProvider, useFeatureFlag, useFeatureFlags, useFeatureVariant, useRolledOut };
//# sourceMappingURL=chunk-WJJBT3ZR.js.map
//# sourceMappingURL=chunk-WJJBT3ZR.js.map